const styles = theme => ({
  container: {
    height: '100%',
  },
  pokerCardContainer: {
    display: 'flex',
    textAlign: 'initial',
  },
  cardsContainer: {
    display: 'flex',
    textAlign: 'initial',
    height: '30px',
  },
  tableCell: {
    height: '30px',
    lineHeight: '30px',
  },
  tableCellWithTwoRow: {
    // extend: 'tableCell',
    display: 'flex',
    flexDirection: 'column',
    lineHeight: '11px',
  },
  dateSpan: {color: theme.textColor, fontSize: '10px'},
  timeSpan: {
    color: theme.textColor,
    fontSize: '12px',
  },
  table: {
    '& table': {
      backgroundColor: theme.backgroundColor,
    },
    '& .ant-table-cell': {
      backgroundColor: theme.backgroundColor,
    },
  },
  tableColumn: {
    minWidth: '85px',
    // maxWidth: '20vw',
    width: '20vw',
    display: 'flex',
    // width: '100vw',
    flexDirection: 'column',
  },
  detailTableArea: {
    display: 'flex',
    width: '100vw',
    height: 275,
    background: theme.gameRoomBackground,
    overflowX: 'auto',
  },
  tableTitleRow: {
    // minWidth: '20vw',
    display: 'flex',
    justifyContent: 'center',
    // clipPath: 'polygon(9% 0, 54% 0, 60% 21%, 95% 21%, 100% 39%, 100% 100%, 0 100%, 0 28%);',
    // background: 'linear-gradient(0deg, rgba(142,66,235,1) 0%, rgba(69,172,250,1) 100%)',
    background: '#1D1D1D',
    boxShadow: 'inset 0px 1px 1px 0px #424242',
    width: '100%',
  },
  titleColumn: {
    // minWidth: '20vw',
    minHeight: '45px',
    textAlign: 'center',
    paddingTop: 7,
    fontSize: '12px',
  },
  tableContentArea: {
    display: 'flex',
    height: '100%',
    // overflowX: 'hidden',
  },
  titleArea: {
    position: 'relative',
    zIndex: -1,
    marginBottom: -35,
    width: '100%',
    height: 45,
    clipPath: 'polygon(9% 0, 54% 0, 60% 21%, 95% 21%, 100% 39%, 100% 100%, 0 100%, 0 28%);',
    background: 'linear-gradient(0deg, rgba(142,66,235,1) 0%, rgba(69,172,250,1) 100%)',
  },
  tableContentColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    minWidth: '85px',
    borderRight: '0.5px solid #6E6D6E',
  },
  playerInfoContainer: {
    margin: '7px 0',
    width: '100%',
  },
  label: {
    // fontSize:10
    marginBottom: 10,
  },
  contentArea: {
    display: 'flex',
    width: '100%',
    flexDirection: 'column',
  },
  buttonRow: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  winnerInfoArea: {
    width: '100%',
  },
  title: {
    width: '100%',
    height: '23px',
    color: 'white',
    // background: 'linear-gradient(90deg, #33C4E8 0%, #4A65F2 100%)',
    background: '#181C26',
    textAlign: 'center',
  },
  content: {
    display: 'flex',
    // justifyContent: 'space-around',
    width: '100%',
    overflowX: 'auto',
    height: '100%',
  },
  previousButton: {
    margin: '0 5px',
    color: '#9d9d9d',
    '&.ant-btn:hover, &.ant-btn:focus, &.ant-btn:active': {
      color: '#9d9d9d',
      borderColor: 'transparent',
    },
    '&.ant-btn.ant-btn-background-ghost': {
      color: '#9d9d9d',
      borderColor: 'transparent',
    },
  },
  noRecord: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: ' 14px',
    width: '100%',
  },
  infiniteScrollContainer: {
    maxHeight: '384px',
    overflow: 'auto',
    borderTopLeftRadius: '4px',
    borderTopRightRadius: '4px',
  },
  loadingArea: {
    background: theme.gameRoomBackground,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 30,
    borderBottom: `1px solid ${theme.borderColor} !important`,
    color: '#A9AAAC',
  },
  spinIcon: {
    color: theme.textColor,
    fontSize: 35,
  },
});

export default styles;
